import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeSubstancePreviousNameCodeFields } from "../Entity/TreeNodeSubstancePreviousNameCodeFields";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeSubstancePreviousNameCodeFieldsList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Previous Name / Codes ({param})');
      this.parent = parent;
      this.labelNodeName = 'Previous Name / Codes';      
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(): Art57Node[] | null {
      let node = new TreeNodeSubstancePreviousNameCodeFields(this.ioc!, this);
      this.children?.push(node);
  
      this.refreshLabel();
      return [node];
    }
  
    override getMessage(): any {
      let developmentsubstancenames: Art57Node[] = [];
      this.children?.forEach((node) => {
        let developmentsubstancename = node as Art57Node;
        developmentsubstancenames.push(developmentsubstancename.getMessage());
      });
  
      if (developmentsubstancenames.length > 0) {
        return {
          developmentsubstancenames: {
            developmentsubstancename: developmentsubstancenames,
          },
        };
      } else {
        return undefined;
      }
    }
  
    override getHeaders(): string[] {
      return ['Substance Name or Code', 'Is Name or Code'];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeSubstancePreviousNameCodeFieldsList =
        new TreeNodeSubstancePreviousNameCodeFieldsList(this.ioc!, newParent);
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      return clonedNode;
    }
  }